import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { DomainContext } from '../../context/DomainContext'
import { PrivilegeContext } from '../../context/PrivilegesContext'
import { useTranslation } from 'react-i18next'
import { CONTROLLER_NAMES, ROLES } from '../../data/Constant'

export const LoadListDefault = { endPoint: () => { }, params: [], depArr: [], defaultValue: {}, allowFetch: true }

export const useGet = (callObject = LoadListDefault) => {
    const { endPoint, params, depArr, defaultValue, allowFetch } = useMemo(() => callObject, [callObject])


    const { setLoading } = useContext(DomainContext)

    const { authorizedPages, privileges, userRoleId } = useContext(PrivilegeContext)
    const [isPending, toggleIsPending] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const [result, setResult] = useState(defaultValue)

    const { i18n } = useTranslation()

    const isLookup = useMemo(() => `${endPoint}`.toLocaleLowerCase().includes('lookup'), [endPoint])

    const isAuthForHomeEndPoint = useMemo(() => authorizedPages.find(allowedScreens => allowedScreens.id == (CONTROLLER_NAMES[`${endPoint}`.split('/')[1]]))?.privileges?.canGet, [authorizedPages])

    const isAllowedToFetch = useMemo(() => !!(userRoleId == ROLES.SUPER_ADMIN || isLookup || privileges?.canGet || isAuthForHomeEndPoint), [endPoint])

    const fetchData = useCallback(() => {
        setLoading(l => l + 1)
        toggleIsPending(prev => true)
        endPoint?.(...params)?.then(res => {
            setTotalCount(res?.totalCount)
            setResult(res?.data)

        })?.catch(err => {
        })?.finally(() => {
            setLoading(l => l - 1)
            toggleIsPending(prev => false)
        })


    }, [...[...params, , ...depArr], allowFetch, isAllowedToFetch, endPoint])


    useEffect(() => {
        if (!isAllowedToFetch && !allowFetch) return
        fetchData()
    }, [...[...params, ...depArr], allowFetch, isAllowedToFetch, endPoint, i18n?.language])


    return { totalCount, result, isPending: isPending , fetchData }
}






